// extracted by mini-css-extract-plugin
export default {"root":"SuccessStub_root__IUQrR","icon":"SuccessStub_icon__zUh80","title":"SuccessStub_title__z6tbL","description":"SuccessStub_description__8FDou"};